/* OTP resend / channel toggle hooks (placeholder). */
(function () {
    window.MDMeals = window.MDMeals || {};
})();
